import React, { useEffect, useState } from "react";


export default function PeriodistaItem( {img, name, text} ) {

    const [close, setClose] = useState(false)

    const closeF = () => {
      setClose(!close)
    }
   

  return (
    
    <div onClick={close ?
        null
     : closeF} className={`profile-cont ${close ? "profile-cont-open" : ""} `}>
    <img className="profile-pic" src={img} alt="" />
    <p className="profile-name"> {name} </p>
    <p className={`profile-description ${!close ? "ellipsis" : "biggertext"} `} > {text} </p>
    {!close ? "" : <img onClick={closeF} width="24" height="24" src="https://img.icons8.com/plumpy/24/delete-sign--v1.png" alt="delete-sign--v1"/> }
    {!close ? <img className="plus2" width="16" height="16" src="https://img.icons8.com/material-outlined/24/plus--v1.png" alt="plus--v1"/> : <></>}
  </div>

  )
}
